import { render, staticRenderFns } from "./TypeBox.vue?vue&type=template&id=3888383c&scoped=true&"
import script from "./TypeBox.vue?vue&type=script&lang=ts&"
export * from "./TypeBox.vue?vue&type=script&lang=ts&"
import style0 from "./TypeBox.vue?vue&type=style&index=0&id=3888383c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3888383c",
  null
  
)

export default component.exports